"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelWrapper = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var __1 = require("../..");
var LabelWrapper = function (_a) {
    var labelContent = _a.labelContent, className = _a.className, children = _a.children, htmlProps = tslib_1.__rest(_a, ["labelContent", "className", "children"]);
    return (React.createElement("label", tslib_1.__assign({}, htmlProps, { className: __1.ClassNames.concat('arm-label-wrapper', className) }),
        React.createElement("span", { className: "arm-label-wrapper-content" }, labelContent),
        children));
};
exports.LabelWrapper = LabelWrapper;
